/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-prototype-builtins */
import { createSlice } from "@reduxjs/toolkit";

const authorizationCodeInitialState = {
  authorizationCode: null,
};

const authorizationCodeSlice = createSlice({
  name: "authorizationCode",
  initialState: authorizationCodeInitialState,
  reducers: {
    setAuthorizationCode(state, action) {
      state.authorizationCode = action.payload;
    },
  },
});

export const authorizationCodeSliceActions = authorizationCodeSlice.actions;

export default authorizationCodeSlice;
